// import { useEffect, useState } from "react";
// import arrowLeft from "../../../Assets/icon/arrow-narrow-left.svg";
// import { useNavigate } from "react-router-dom";
// import { useHeader } from "../../../Providers/HeaderContextProvider";
// import "./style.css";
// import "../../../Pages/TermsofUse/style.css";
// import ToggleButton from "../../../Components/ToggleButton/ToggleButton";
// import {
//   getNotificationSettings,
//   updateNotificationSettings,
// } from "../../../Services/settingsServices";
// // import Loader from "react-js-loader";

// function NotificationSettings() {
//   const navigate = useNavigate();
//   const { setHeaderContent } = useHeader();
//   const [notificationSettings, setnotificationSettings] = useState({
//     general: false,
//     invite: false,
//     coach: false,
//   });
//   useEffect(() => {
//     setHeaderContent(false);
//     getNotificationSettings().then((e) => {
//       setnotificationSettings({
//         general: e?.general,
//         invite: e?.invite,
//         coach: e?.coach,
//       });
//     });
//   }, []);

//   const onToggleSelection = (name) => {

//     setnotificationSettings((prevState) => ({
//       ...prevState,
//       [name]: !prevState[name],
//     }));

//     updateNotificationSettings({
//       [name]: !notificationSettings[name],
//     });
//   };

//   return (
//     <div>
//       <GradientBackground>
//         <header className="termsofuse-header">
//            {isLoading && (
//                 <div className="loader-df-container">
//                   <Loader
//                     type="spinner-cub"
//                     bgColor={"#2D50A7"}
//                     color={"#3D6DEB"}
//                     // title={"spinner-cub"}
//                     size={45}
//                   />
//                 </div>
//               )}
//           <div className="termsofuse-gradient-background">
//             <div className="termsofuse-nav-container">
//               <div
//                 className="termsofuse-logo-container"
//                 onClick={() => navigate(-1)}
//               >
//                 <img
//                   src={arrowLeft}
//                   alt="Back"
//                   className="termsofuse-back-button"
//                 />
//               </div>
//               <h1 className="termsofuse-title">
//                 Notifications <span className="hide-on-desktop">Settings</span>
//               </h1>
//               <div className="termsofuse-space"></div>
//             </div>
//             <div className="termsofuse-last-subtext">Push notifications</div>
//           </div>
//         </header>
//         <div className="notification-set-hero-container">
//           <div className="notification-set-accord">
//             <div className="notification-set-accord-title-container">
//               <div className="not-set-head">General communications</div>
//               <div className="not-set-sub">
//                 Lorem ipsum dolor sit amet, consectetur adipiscing elit.
//               </div>
//             </div>
//             <div>
//               <ToggleButton
//                 isChecked={notificationSettings.general}
//                 onChange={() => onToggleSelection("general")}
//                 name={"general"}
//               />
//             </div>
//           </div>
//           <div className="notification-set-accord">
//             <div className="notification-set-accord-title-container">
//               <div className="not-set-head">Connection requests</div>
//               <div className="not-set-sub">
//                 Lorem ipsum dolor sit amet, consectetur adipiscing elit.
//               </div>
//             </div>
//             <div>
//               <ToggleButton
//                 isChecked={notificationSettings.invite}
//                 onChange={() => onToggleSelection("invite")}
//                 name={"invite"}
//               />
//             </div>
//           </div>
//           <div className="notification-set-accord">
//             <div className="notification-set-accord-title-container">
//               <div className="not-set-head">Life coach follow-ups</div>
//               <div className="not-set-sub">
//                 Lorem ipsum dolor sit amet, consectetur adipiscing elit.
//               </div>
//             </div>
//             <div>
//               <ToggleButton
//                 isChecked={notificationSettings.coach}
//                 onChange={() => onToggleSelection("coach")}
//                 name={"coach"}
//               />
//             </div>
//           </div>
//         </div>
//       </GradientBackground>
//     </div>
//   );
// }

// export default NotificationSettings;

import { useEffect, useState } from "react";
import arrowLeft from "../../../Assets/icon/arrow-narrow-left.svg";
import { useNavigate } from "react-router-dom";
import { useHeader } from "../../../Providers/HeaderContextProvider";
import "./style.css";
import "../../../Pages/TermsofUse/style.css";
import ToggleButton from "../../../Components/ToggleButton/ToggleButton";
import {
  getNotificationSettings,
  updateNotificationSettings,
} from "../../../Services/settingsServices";
import GradientBackground from "../../../Components/AddRelationshipHeaderGradient";
import Loader from "react-js-loader";

function NotificationSettings() {
  const navigate = useNavigate();
  const { setHeaderContent } = useHeader();

  const [notificationSettings, setnotificationSettings] = useState({
    general: false,
    invite: false,
    coach: false,
  });

  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    setHeaderContent(false);
    getNotificationSettings().then((e) => {
      setnotificationSettings({
        general: e?.general,
        invite: e?.invite,
        coach: e?.coach,
      });
    });
  }, []);

  // Clear error after 3 seconds
  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => {
        setErrorMessage("");
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  const onToggleSelection = async (name) => {
    const updatedValue = !notificationSettings[name];

    setnotificationSettings((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    try {
      setIsLoading(true);
      await updateNotificationSettings({ [name]: updatedValue });
    } catch (error) {
      // Rollback toggle on error
      setnotificationSettings((prev) => ({
        ...prev,
        [name]: !updatedValue,
      }));
      setErrorMessage(error.response?.data?.message || "Something went wrong !");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
        <header className="termsofuse-header">
          <div className="termsofuse-gradient-background">
            <div className="termsofuse-nav-container">
              <div
                className="termsofuse-logo-container"
                onClick={() => navigate(-1)}
              >
                <img
                  src={arrowLeft}
                  alt="Back"
                  className="termsofuse-back-button"
                />
              </div>
              <h1 className="termsofuse-title">
                Notifications <span className="hide-on-desktop">Settings</span>
              </h1>
              <div className="termsofuse-space"></div>
            </div>
            <div className="termsofuse-last-subtext">Push notifications</div>
          </div>
        </header>
       
        <div className="notification-set-hero-container">
           {isLoading && (
          <div className="loader-df-container setting-notification">
            <Loader
              type="spinner-cub"
              bgColor={"#2D50A7"}
              color={"#3D6DEB"}
              size={45}
            />
          </div>
        )}
          {["general", "invite", "coach"].map((type) => (
            <div key={type} className="notification-set-accord">
              <div className="notification-set-accord-title-container">
                <div className="not-set-head">
                  {type === "general"
                    ? "General communications"
                    : type === "invite"
                    ? "Connection requests"
                    : "Life coach follow-ups"}
                </div>
                <div className="not-set-sub">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                </div>
              </div>
              <div>
                <ToggleButton
                  isChecked={notificationSettings[type]}
                  onChange={() => onToggleSelection(type)}
                  name={type}
                  disabled={isLoading}
                />
              </div>
            </div>
          ))}

          {/* Show error message if any */}
          {errorMessage && (
            <div
              style={{ color: "red", textAlign: "center", marginTop: "20px" }}
            >
              {errorMessage}
            </div>
          )}
        </div>
    </div>
  );
}

export default NotificationSettings;
